// extracted by mini-css-extract-plugin
export default {"sliderWrap":"revenueSlider_sliderWrap__S0hCv","sliderRangeLabels":"revenueSlider_sliderRangeLabels__i5i+A"};